import React, { useContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import { environmentVar } from "../../config/environmentVar";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { FilterContext } from "../../context/FilterContext";

const FrameProperty = () => {
  const { id } = useParams();
  const { country_code } = useContext(FilterContext);


  const fetchCategoriesData = async ({ queryKey }) => {
    const [, id, country_code] = queryKey;
    let apiUrl = `${
      environmentVar?.apiUrl
    }/api/product/fetch_product_by_id?id=${id}&country_code=${
      country_code || "IN"
    }`;

    const config = {
      method: "get",
      url: apiUrl,
    };

    const response = await axios(config);
    return response?.data?.data;
  };

  const {
    data: productData,
    isLoading,
    error,
    refetch,
  } = useQuery(
    ["productbyidinframeproperty", id, country_code],
    fetchCategoriesData
  );
  
  


  return (
    <>
      <Container>
        <div className="frame-property-header">
          <h2>Product Description</h2>
          <h3>{productData?.[0]?.summary}</h3>
          <ul>
            <li>
              Model Number: <span>{productData?.[0]?.model_number}</span>
            </li>
            <li>
              Shape: <span>{productData?.[0]?.shapeobj?.value}</span>
            </li>
            <li>
              Size: <span>{productData?.[0]?.sizeData?.[0]?.value}</span>
            </li>
            <li>
              Materials: <span>{productData?.[0]?.materialData?.value}</span>
            </li>
            <li>
              Weight: <span>{productData?.[0]?.weightData?.value} g</span>
            </li>
            <li>
              Gender:{" "}
              <span>
                {productData?.[0]?.genderDataArr
                  ?.map((item) => item?.value)
                  .join(", ")}
              </span>
            </li>
            <li>
              Frame Type: <span>{productData?.[0]?.frameTypeObj?.value}</span>
            </li>
            <li>
              Frame Width: <span>{productData?.[0]?.frame_width} mm</span>
            </li>
            <li>
              Lens Height: <span>{productData?.[0]?.lens_height} mm</span>
            </li>
            <li>
              Lens Width : <span>{productData?.[0]?.lens_width} mm</span>
            </li>
            <li>
              Bridge Width: <span>{productData?.[0]?.bridge_width} mm</span>
            </li>
            <li>
              Temple Length: <span>{productData?.[0]?.temple_length} mm</span>
            </li>
          </ul>
        </div>
      </Container>
    </>
  );
};

export default FrameProperty;
